import Menu from './Compartido/Menu.jsx';
import TextosGraciasPaypal from './GraciasPaypal/TextosGraciasPaypal.jsx';
import Footer from './Compartido/Footer.jsx';

const GraciasPaypal = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <TextosGraciasPaypal />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    )
}

export default GraciasPaypal;
